import { useEffect, useState } from 'react';

const navLinks = [
  { label: '深度报道', href: '#deep' },
  { label: '独家专访', href: '#interview' },
  { label: '分类快讯', href: '#feed' },
  { label: '吃瓜话题', href: '#topics' },
  { label: '关于我们', href: '#about' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-300 ${
        scrolled || open
          ? 'border-b border-background-200 bg-background-50/90 backdrop-blur-md'
          : 'border-b border-transparent bg-transparent'
      }`}
    >
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 md:px-6">
        {/* 品牌 */}
        <a href="#breaking" className="flex items-center gap-2 whitespace-nowrap">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-water-flash-fill text-lg" aria-hidden="true" />
          </span>
          <span className="font-heading text-lg font-bold tracking-wide text-foreground-950">
            吃瓜<span className="text-primary-600">新闻</span>
          </span>
        </a>

        {/* 桌面导航 */}
        <nav className="hidden items-center gap-1 md:flex" aria-label="主导航">
          {navLinks.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="rounded-md px-3 py-2 text-sm font-medium text-foreground-700 transition-colors hover:bg-background-200/70 hover:text-primary-700"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden items-center gap-2 md:flex">
          <a
            href="#feed"
            aria-label="搜索"
            className="flex h-9 w-9 items-center justify-center rounded-md text-foreground-700 transition-colors hover:bg-background-200/70 hover:text-primary-700"
          >
            <i className="ri-search-line text-lg" aria-hidden="true" />
          </a>
          <a
            href="#about"
            className="whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            订阅频道
          </a>
        </div>

        {/* 移动端汉堡按钮 */}
        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          aria-label="展开菜单"
          className="flex h-9 w-9 items-center justify-center rounded-md text-foreground-800 hover:bg-background-200/70 md:hidden"
        >
          <i className={open ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'} aria-hidden="true" />
        </button>
      </div>

      {/* 移动端菜单 */}
      {open && (
        <nav
          className="border-t border-background-200 bg-background-50 px-4 pb-4 pt-2 md:hidden"
          aria-label="移动端导航"
        >
          {navLinks.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              className="block rounded-md px-3 py-3 text-base font-medium text-foreground-800 hover:bg-background-200/70"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#about"
            onClick={() => setOpen(false)}
            className="mt-2 block rounded-md bg-primary-500 px-4 py-3 text-center text-base font-medium text-background-50"
          >
            订阅频道
          </a>
        </nav>
      )}
    </header>
  );
}